function MovieIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 1418 1304"
      fill="currentColor"
      className={className}
      style={{
        strokelinejoin: 'round',
      }}
    >
      <path d="M1017.6 44.9c75.7 0 137.2 61.5 137.2 137.2l-3.2 422.5c-22.9 2.9-123.5 22.7-160.2 146 -1.9 190 0 312.6 0 312.9l74.8 0 0-265.1c0-69.8 62.6-126.4 139.7-126.4 77.1 0 139.7 56.7 139.7 126.4 0 7.6-1.8 392.2-1.8 392.2 0 38.3-31.1 69.4-69.4 69.4l-138.8 0c-3.6 0-7.2-0.3-10.7-0.8l0.1 0.2 -837.9 0 0.1-0.2c-3.5 0.5-7.1 0.8-10.7 0.8l-138.8 0c-38.3 0-69.4-31.1-69.4-69.4 0 0-1.8-384.6-1.8-392.2 0-69.8 62.6-126.4 139.7-126.4 77.1 0 139.7 56.7 139.7 126.4l0 265.1 74.8 0c0-0.3 1.9-122.8 0-312.9 -36.7-123.3-137.3-143.1-160.2-146l-0.7-422.5c0-75.7 61.5-137.2 137.2-137.2l620.6 0Z" />
    </svg>
  );
}

export default MovieIcon;
